import { useEffect } from 'react'
import Semaphore from '../Semaphore/Semaphore'
import moment from 'moment'
import { EXCEPCION_GARANTIA_ESTADO, EXCEPCION_GARANTIA_TIPO, GARANTIA_TIPO } from '../../pages/Utils/Constants';
import './GarantiaInfo.css'
import { pdfjs } from 'react-pdf';
import numeral from 'numeral'
import CardEx from '../Cards/CardEx';
import { Loading } from '../Loading/Loading';

export default function GarantiaInfo({ garantia }) {

    //pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.js`;
    pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

    useEffect(() => {
        if (garantia) {
            // debugger;
            //  // Cambio de Tipo de Garantia para las Garantias con Excepción
            //  if(garantia.is_excepcion) {
            //     if(garantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA) {
            //         garantia.tipo_garantia.codigo = GARANTIA_TIPO.GAR0_EFECTIVO
            //     } else if(garantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR0_EFECTIVO) {
            //         garantia.tipo_garantia.codigo = GARANTIA_TIPO.GAR1_CARTA_FIANZA
            //     }
            // }


            console.log(garantia, "view infoi")
        }
    }, [garantia])

    const getTitleByTypeGarantia = (code) => {
        if (code === GARANTIA_TIPO.GAR1_CARTA_FIANZA) {
            return 'Carta Fianza'
        } else if (code === GARANTIA_TIPO.GAR0_EFECTIVO) {
            return 'Operaciones Efectivo'
        } else if (code === GARANTIA_TIPO.GAR2_SIN_GARANTIA) {
            return 'Sin Garantía'
        } else {
            return ''
        }
    }

    const getUrlFileName = () => {
        var fileName = "";

        switch (garantia?.tipo_garantia.codigo) {
            case GARANTIA_TIPO.GAR1_CARTA_FIANZA:
                fileName = garantia?.url_filename_carta_fianza;
                break;
            case GARANTIA_TIPO.GAR0_EFECTIVO:
                fileName = garantia?.url_filename_operacion;
                break;
            default:
                break;
        }

        return fileName;
    }

    // const getCSPHeader = () => {
    //     return `Content-Security-Policy': "default-src 'self'; script-src 'self' 'unsafe-inline';`;
    // }

    if (!garantia) {
        return (<>
            <Loading></Loading>
        </>);
    }

    return (
        <>
            <CardEx title={`Nro Contrato ${garantia?.nro_contrato}`}>
                <div className='row mt-2 mb-2'>
                    <div className='col-12 d-flex justify-content-center'>
                        <Semaphore
                            caption='LO'
                            size={'40px'}
                            fontSize={'16px'}
                            tooltipTitle={"Revisión de Locatario"}
                            lastUpdateDate={garantia?.revision_locatario?.fecha_revision}
                            lastUpdatedBy={garantia?.revision_locatario?.usuario_revisor}
                            tooltipDescription={garantia?.revision_locatario?.observaciones}
                            color={garantia?.revision_locatario?.semaforo_color}>
                        </Semaphore>
                        <Semaphore
                            caption='CO'
                            size={'40px'}
                            fontSize={'16px'}
                            tooltipTitle={"Revisión de Cobranza"}
                            lastUpdateDate={garantia?.revision_cobranza?.fecha_revision}
                            lastUpdatedBy={garantia?.revision_cobranza?.usuario_revisor}
                            tooltipDescription={garantia?.revision_cobranza?.observaciones}
                            color={garantia?.revision_cobranza?.semaforo_color}>
                        </Semaphore>
                        {((garantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA && !garantia.is_excepcion)
                            || (garantia.tipo_garantia.codigo === GARANTIA_TIPO.GAR0_EFECTIVO
                                && garantia.excepcion.codigo_tipo_excepcion === EXCEPCION_GARANTIA_TIPO.EFECTIVO_A_CARTA_FIANZA)) ?
                            (
                                <Semaphore
                                    caption='TE'
                                    size={'40px'}
                                    fontSize={'16px'}
                                    tooltipTitle={"Revisión de Tesorería"}
                                    lastUpdateDate={garantia?.revision_tesoreria?.fecha_revision}
                                    lastUpdatedBy={garantia?.revision_tesoreria?.usuario_revisor}
                                    tooltipDescription={garantia?.revision_tesoreria?.observaciones}
                                    color={garantia?.revision_tesoreria?.semaforo_color}>
                                </Semaphore>
                            ) : null
                        }

                    </div>
                </div>
                <div className='row mt-3 mb-2'>
                    <div className='col-12 d-flex justify-content-center'>
                        <span className='badge badge-pill badge-secondary badge-text-small'>
                            {garantia?.estado_garantia?.nombre}
                        </span>
                        {
                            garantia?.is_excepcion
                            && <span className='badge badge-pill badge-danger badge-text-small ms-3'>Con Excepción: {garantia?.excepcion?.nombre_tipo_excepcion}</span>
                        }
                    </div>
                </div>
                <div className='row mb-5 mt-8 py-1 rounded-top bg-grey'>
                    <div className='col-12 py-1 d-flex align-items-center'>
                        <i className="fi fi-rr-ballot-check fs-3 me-2"></i>
                        <span className='fs-4 text-gray-light'>Datos Generales</span>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 col-xl-6'>
                        <div className='row mb-6 align-items-center'>
                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                <label className='fs-5 fw-bold'>Ruc</label>
                            </div>
                            <div className='col-12 col-sm w-sm-100'>
                                <span className='ms-6'>{garantia?.ruc}</span>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-xl-6'>
                        <div className='row mb-6 align-items-center'>
                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                <label className='fs-5 fw-bold '>Razon Social</label>
                            </div>
                            <div className='col-12 col-sm w-sm-100'>
                                <span className='ms-6'>{garantia?.razon_social}</span>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-xl-6'>
                        <div className='row mb-6 align-items-center'>
                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                <label className='fs-5 fw-bold '>Nombre Comercial</label>
                            </div>
                            <div className='col-12 col-sm w-sm-100'>
                                <span className='ms-6'>{garantia?.nombre_comercial}</span>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-xl-6'>
                        <div className='row mb-6 align-items-center'>
                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                <label className='fs-5 fw-bold '>Mall</label>
                            </div>
                            <div className='col-12 col-sm w-sm-100'>
                                <span className='ms-6'>{garantia?.nombre_mall}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row mt-2 mb-5 py-1 rounded-top bg-grey'>
                    <div className='col-12 py-1 d-flex align-items-center'>
                        <i className="fi fi-rr-file-invoice-dollar fs-3 me-2"></i>
                        <span className='fs-4 text-gray-light'>{getTitleByTypeGarantia(garantia?.tipo_garantia?.codigo)}</span>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 col-xl-6'>
                        {garantia?.tipo_garantia?.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA ? (
                            <div className='row mb-6 align-items-center'>
                                <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                    <label className='fs-5 fw-bold '>Nro Carta Fianza</label>
                                </div>
                                <div className='col-12 col-sm w-sm-100'>
                                    <a href={getUrlFileName()} target='_blank' className='ms-6' rel="noreferrer"><i className="fi fi-rr-download fs-4 me-2"></i> {garantia?.nro_carta_fianza}</a>

                                </div>
                            </div>
                        ) : garantia?.tipo_garantia?.codigo === GARANTIA_TIPO.GAR0_EFECTIVO ? (
                            <div className='row mb-6 align-items-center'>
                                <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                    <label className='fs-5 fw-bold '>Nro Operaci&oacute;n</label>
                                </div>
                                <div className='col-12 col-sm w-sm-100'>
                                    <a href={getUrlFileName()} target='_blank' className='ms-6' rel="noreferrer"><i className="fi fi-rr-download fs-4 me-2"></i> {garantia?.nro_operacion}</a>
                                </div>
                            </div>
                        ) : null}
                    </div>

                    {garantia?.tipo_garantia?.codigo === GARANTIA_TIPO.GAR1_CARTA_FIANZA && (
                        <div className='col-12 col-xl-6'>
                            <div className='row mb-6 align-items-center'>
                                <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                    <label className='fs-5 fw-bold '>Vigencia</label>
                                </div>
                                <div className='col-12 col-sm w-sm-100'>
                                    <span className='ms-6'>
                                        {garantia?.fecha_emision_carta_fianza && garantia?.fecha_vencimiento_carta_fianza && `${moment(garantia?.fecha_emision_carta_fianza).format("DD/MM/yyyy")} - ${moment(garantia?.fecha_vencimiento_carta_fianza).format("DD/MM/yyyy")}`}
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className='col-12 col-xl-6'>
                        <div className='row mb-6 align-items-center'>
                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                <label className='fs-5 fw-bold '>Importe</label>
                            </div>
                            <div className='col-12 col-sm w-sm-100'>
                                <span className='ms-6'>{garantia?.codigo_moneda} {numeral(garantia?.importe).format('0,0.00')}</span>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-xl-6'>
                        <div className='row mb-6 align-items-center'>
                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                <label className='fs-5 fw-bold '>Banco</label>
                            </div>
                            <div className='col-12 col-sm w-sm-100'>
                                <span className='ms-6'>{garantia?.nombre_banco}</span>
                            </div>
                        </div>
                    </div>
                </div>

                {garantia?.excepcion.codigo_estado_excepcion === EXCEPCION_GARANTIA_ESTADO.APROBADO.CODE &&
                    garantia?.is_excepcion ? (
                    <>

                        <div className='row mt-2 mb-5 py-1 rounded-top bg-grey'>
                            <div className='col-12 py-1 d-flex align-items-center'>
                                <i className="fi fi-rr-replace fs-3 me-2"></i>
                                <span className='fs-4 text-gray-light'>Datos de la Excepción</span>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12 col-xl-6'>
                                <div className='row mb-6 align-items-center'>
                                    <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                        <label className='fs-5 fw-bold '>Tipo Excepción</label>
                                    </div>

                                    <div className='col-12 col-sm w-sm-100'>
                                        <span className='ms-6'>{garantia?.excepcion.nombre_tipo_excepcion}</span>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-xl-6'>
                                <div className='row mb-6 align-items-center'>
                                    <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                        <label className='fs-5 fw-bold '>Fecha de Venc.</label>
                                    </div>
                                    <div className='col-12 col-sm w-sm-100'>
                                        <span className='ms-6'>
                                            {garantia?.excepcion.fecha_vencimiento && (
                                                `${moment(garantia?.excepcion.fecha_vencimiento).format("DD/MM/yyyy")}`
                                            )}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-xl-6'>
                                <div className='row mb-6 align-items-center'>
                                    <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                        <label className='fs-5 fw-bold '>Importe</label>
                                    </div>
                                    <div className='col-12 col-sm w-sm-100'>
                                        <span className='ms-6'>{garantia?.excepcion.codigo_moneda} {numeral(garantia?.excepcion.importe).format('0,0.00')}</span>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-xl-6'>
                                <div className='row mb-6 align-items-center'>
                                    <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                        <label className='fs-5 fw-bold '>Sustento</label>
                                    </div>
                                    <div className='col-12 col-sm w-sm-100'>
                                        <a href={garantia?.excepcion.url_file_name_adjunto} target='_blank' rel='noreferrer' className='ms-6'>
                                            <i className="fi fi-rr-download fs-4"></i> {garantia?.excepcion.file_name_adjunto}</a>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12'>
                                <div className='row mb-6 align-items-center'>
                                    <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                        <label className='fs-5 fw-bold '>Motivo</label>
                                    </div>
                                    <div className='col-12 col-sm w-sm-100'>
                                        <span className='ms-6 d-block'>{garantia?.excepcion.motivo}</span>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className='row'>

                            {garantia?.excepcion?.codigo_tipo_excepcion === EXCEPCION_GARANTIA_TIPO.CARTA_FIANZA_A_EFECTIVO ? (
                                <>
                                    <div className='col-12 col-xl-6'>
                                        <div className='row mb-6 align-items-center'>
                                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                                <label className='fs-5 fw-bold '>Nro Operaci&oacute;n</label>
                                            </div>
                                            <div className='col-12 col-sm w-sm-100'>
                                                {garantia?.excepcion.url_file_name_adjunto_excepcion ? (
                                                    <a href={garantia?.excepcion.url_file_name_adjunto_excepcion} target='_blank' className='ms-6' rel="noreferrer">
                                                        <i className="fi fi-rr-download fs-4 me-2"></i>
                                                        {garantia?.excepcion.nro_operacion_efectivo}
                                                    </a>
                                                ) : (
                                                    <span className='ms-6'>{garantia?.excepcion.nro_operacion_efectivo}</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-12 col-xl-6'>
                                        <div className='row mb-6 align-items-center'>
                                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                                <label className='fs-5 fw-bold '>Fecha Depósito</label>
                                            </div>
                                            <div className='col-12 col-sm w-sm-100'>
                                                <span className='ms-6'>
                                                    {garantia?.excepcion.fecha_deposito_efectivo && (
                                                        `${moment(garantia?.excepcion.fecha_deposito_efectivo).format("DD/MM/yyyy")}`
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : garantia?.excepcion?.codigo_tipo_excepcion === EXCEPCION_GARANTIA_TIPO.EFECTIVO_A_CARTA_FIANZA ? (
                                <>
                                    <div className='col-12 col-xl-6'>
                                        <div className='row mb-6 align-items-center'>
                                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                                <label className='fs-5 fw-bold '>Nro Carta Fianza</label>
                                            </div>
                                            <div className='col-12 col-sm w-sm-100'>
                                                {garantia?.excepcion.url_file_name_adjunto_excepcion ? (
                                                    <a href={garantia?.excepcion.nro_carta_fianza} target='_blank' className='ms-6' rel="noreferrer">
                                                        <i className="fi fi-rr-download fs-4 me-2"></i>
                                                        {garantia?.excepcion.nro_carta_fianza}
                                                    </a>
                                                ) : (
                                                    <span className='ms-6'>{garantia?.excepcion.nro_carta_fianza}</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-12 col-xl-6'>
                                        <div className='row mb-6 align-items-center'>
                                            <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                                <label className='fs-5 fw-bold '>Fecha de Vigencia</label>
                                            </div>
                                            <div className='col-12 col-sm w-sm-100'>
                                                <span className='ms-6'>
                                                    {garantia?.excepcion.fecha_emision_carta_fianza && garantia?.excepcion.fecha_vencimiento_carta_fianza && (
                                                        `${moment(garantia?.excepcion.fecha_emision_carta_fianza).format("DD/MM/yyyy")} - ${moment(garantia?.excepcion.fecha_vencimiento_carta_fianza).format("DD/MM/yyyy")}`
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </>

                            ) : null}
                            <div className='col-12 col-xl-6'>
                                <div className='row mb-6 align-items-center'>
                                    <div className='col-12 mb-2 mb-sm-0 text-sm-end container-label'>
                                        <label className='fs-5 fw-bold '>Banco</label>
                                    </div>
                                    <div className='col-12 col-sm w-sm-100'>
                                        <span className='ms-6'>{garantia?.excepcion.nombre_banco}</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </>
                )
                    : null}

            </CardEx>
            {/* <div className='separator-h'></div>
            {
                garantia?.tipo_garantia?.codigo != GARANTIA_TIPO.GAR2_SIN_GARANTIA 
                &&  <CardEx title={`Adjunto de ${getTitleByTypeGarantia(garantia?.tipo_garantia?.codigo)}`}>
                        {garantia && getUrlFileName() !== null && getUrlFileName().length > 0 &&
                        <object data={`${getUrlFileName()}#zoom=page-width`} type="application/pdf" width="100%" height="500px" style={{ maxWidth: "100%", height: "900px" }} >
                            <p>Alternative text - include a link <a href={getUrlFileName()}>to the PDF!</a></p>
                        </object>}                 
                    </CardEx>
            } */}

            {/* <div className="accordion mb-3" id="accordion-main">
                <div className="accordion-item">
                    <h2 className="accordion-header" id={`id_stay_open_heading__01`}>
                        <button className="accordion-button d-flex align-items-center" type="button" data-bs-toggle="collapse" data-bs-target={`#id_stay_open_collapse__01`} aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                            <i className="fi fi-rr-file-invoice-dollar fs-1 me-2"></i>
                            <h2 className='mb-0'>Contrato N&#176; {garantia?.nro_contrato}</h2>
                        </button>
                    </h2>
                    <div id={`id_stay_open_collapse__01`} className="accordion-collapse collapse show" aria-labelledby={`id_stay_open_heading__01`}>
                        <div className="accordion-body">

                        </div>
                    </div>
                </div>
            </div>

            <div className="accordion" id="accordion-adjunto">
                <div className="accordion-item">
                    <h2 className="accordion-header" id={`id_stay_open_heading__02`}>
                        <button className="accordion-button d-flex align-items-center" type="button" data-bs-toggle="collapse" data-bs-target={`#id_stay_open_collapse__02`} aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                            <i className="fi fi-rr-file-invoice-dollar fs-1 me-2"></i>
                            <h2 className='mb-0'>Adjunto de {getTitleByTypeGarantia(garantia?.tipo_garantia?.codigo)}</h2>
                        </button>
                    </h2>
                    <div id={`id_stay_open_collapse__02`} className="accordion-collapse collapse show" aria-labelledby={`id_stay_open_heading__02`}>
                        <div className="accordion-body">

                            {garantia && getUrlFileName() !== null && getUrlFileName().length > 0 &&
                                <object data={`${getUrlFileName()}#zoom=page-width`} type="application/pdf" width="100%" height="500px" style={{ maxWidth: "100%", height: "900px" }} >
                                    <p>Alternative text - include a link <a href={getUrlFileName()}>to the PDF!</a></p>
                                </object>}
                        </div>
                    </div>
                </div>
            </div> */}

        </>
    )
}
